import { render, staticRenderFns } from "./HeaderContact.vue?vue&type=template&id=dd6c6c0a&scoped=true"
import script from "./HeaderContact.vue?vue&type=script&lang=js"
export * from "./HeaderContact.vue?vue&type=script&lang=js"
import style0 from "./HeaderContact.vue?vue&type=style&index=0&id=dd6c6c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6c6c0a",
  null
  
)

export default component.exports